import endpoints from './endpoints';
import request from './request';

const authApi = {
    login(credentials) {
        return request.post(
            endpoints.auth.login,
            credentials,
        );
    },
};

export default authApi;


// WEBPACK FOOTER //
// ./src/api/authApi.js